/*
 * Animation Loop
 *
 * @author				Matt Gifford
 * @copyright			2020 Brigada Limited
 */
define("brigada/animations", ["brigada/device", "brigada/util","brigada/jquery"], (device, util, jQuery) => {
	/*
	 * @private	The private reference to this class
	 */
	const _this = {
		renderLoopStarted: false
	};


	/**
	 * Init
	 *
	 * @return        void
	 */
	_this.init = () => {
		// Auto run animations in WP Admin
		if (document.body.classList.contains('block-editor-page')) {
			let renderLoop = function () {
				for (let node of document.getElementsByClassName('animation-queued')) {
					node.classList.add('animate');
				}
				requestAnimationFrame(renderLoop);
			};
			requestAnimationFrame(renderLoop);
			return;
		}

		// Start render loop
		if (util.documentTabActive()) {
			_this.initRenderLoop();
		} else {
			util.documentTabActive(function (active) {
				if (active && !_this.renderLoopStarted) {
					_this.renderLoopStarted = true;
					_this.initRenderLoop();
				}
			});
		}

		// Trigger animations on first component if page loads scrolled
		if (0 < window.scrollY) {
			jQuery('#content .component:first-child').each(function(index, node) {
				jQuery('.animation-queued').removeClass('animation-queued').addClass('animate');
			});
		}
	};

	/**
	 * Queues the animations
	 *
	 * @return        void
	 */
	_this.initRenderLoop = function () {
		let queuedAnimationNodes;
		let allAnimationNodes;
		let rect;
		const queue = [];
		queuedAnimationNodes = document.getElementsByClassName('animation-queued');
		allAnimationNodes = document.getElementsByClassName('animation');

		// Internet explorer doesn't support unique class names on inline svg, so filter those out for IE
		if (navigator.userAgent.toLowerCase().indexOf('msie') !== -1 || navigator.userAgent.toLowerCase().indexOf('trident') !== -1) {
			// filter out inline SVGs
			queuedAnimationNodes = _this.filterNodesByTagNames(queuedAnimationNodes, ['svg']);
			allAnimationNodes = _this.filterNodesByTagNames(allAnimationNodes, ['svg']);
		}

		setInterval(() => {
			if (queue.length === 0) {
				return;
			}
			const node = queue.shift();
			node.classList.add('animate');
		}, 50);

		const renderLoop = () => {
			// Animate forwards, inside viewport
			for (let node of queuedAnimationNodes) {
				try {
					a = node.classList.contains('animation-queued');
				} catch (e) {
					console.log(a.tagName);
					console.log(a);
					console.log(e);
				}
				if (node.classList.contains('animation-queued')) {
					rect = node.getBoundingClientRect();

					if (
						(0 <= rect.top && rect.top <= window.innerHeight * 0.98) || (0 <= rect.bottom && rect.bottom <= window.innerHeight * 0.98)
					) {
						queue.push(node);
						node.classList.remove('animation-queued');
					}
				}
			}

			// Animate backwards, outside viewport
			for (let node of allAnimationNodes) {
				if (node.classList.contains('animate') && node.classList.contains('animation-multiple')) {
					rect = node.getBoundingClientRect();

					// Check if outside viewport
					if (((window.innerHeight * -0.5 <= rect.top && rect.top <= window.innerHeight * 1.5) || (window.innerHeight * -0.5 <= rect.bottom && rect.bottom <= window.innerHeight * 1.5)) === false) {
						// Outside viewport
						node.classList.remove('animate');
						node.classList.add('animation-queued');
					}
				}
			}

			// request new frame to keep the animation going
			requestAnimationFrame(renderLoop);
		};

		// start the render loop
		requestAnimationFrame(renderLoop);
	};


	/**
	 * Filters tag names from the node list
	 *
	 * @param        nodes        The node list array
	 * @param        filters        The tag name array
	 * @return        array
	 */
	_this.filterNodesByTagNames = function (nodes, filters) {
		let filteredNodes = [];
		for (let node of nodes) {
			if (filters.indexOf(node.tagName.toLowerCase()) === -1) {
				filteredNodes.push(node);
			}
		}

		return filteredNodes;
	};


	// Return the site object
	return _this;
});